import React from "react";
import { Checkbox, Label, Slider } from "@fluentui/react-components";
import { type ChartStyleSectionProps, useSliderStyles } from "./shared";

const FunnelStyle: React.FC<ChartStyleSectionProps> = ({ chartStyle: cs, onStyleChange }) => {
  const styles = useSliderStyles();
  return (
    <>
      <Checkbox
        label="Sort descending (largest on top)"
        checked={cs.sortDescending ?? true}
        onChange={(_, data) => onStyleChange({ sortDescending: !!data.checked })}
      />
      <Checkbox
        label="Show conversion rates"
        checked={cs.showConversion ?? false}
        onChange={(_, data) => onStyleChange({ showConversion: !!data.checked })}
      />
      <div className={styles.sliderField}>
        <Label size="small">Gap Size</Label>
        <div className={styles.sliderRow}>
          <Slider
            min={0} max={10} step={1}
            value={cs.gapSize ?? 1}
            onChange={(_, data) => onStyleChange({ gapSize: data.value })}
            style={{ flex: 1 }}
          />
          <span className={styles.sliderValue}>{cs.gapSize ?? 1}px</span>
        </div>
      </div>
    </>
  );
};

export default FunnelStyle;